import { makeRange } from 'helpers/makeRange';
import { IScaleRange } from 'modules/admin-panel/pages/results/models';

export const makeAverages = (maxValue: number, minValue: number): number[] =>
	makeRange(maxValue).filter((i) => i >= minValue);

export const getMarksAverages = (scaleRange: IScaleRange) => ({
	all: makeRange(scaleRange.positive.max),
	min: makeRange(scaleRange.negative.max),
	mid: makeAverages(scaleRange.neutral.max, scaleRange.neutral.min),
	max: makeAverages(scaleRange.positive.max, scaleRange.positive.min),
});
